<template>
  <v-dialog
    v-model="dialog"
    persistent
    overlay-opacity="0"
    max-width="290"
  >
    <v-card>
      <v-card-title class="text-center">
        <small>{{$t('session.publisherError.message1')}}</small>
      </v-card-title>
      <v-card-text class="pb-0">
        <p>{{$t('session.publisherError.message2')}}</p>
        <p class="mb-0">{{$t('session.publisherError.message3')}}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary darken-1"
          text
          @click="goToChat()"
        >
          <b>{{$t('session.publisherError.chat')}}</b>
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="handler()"
        >
          <b>{{$t('session.publisherError.retry')}}</b>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class PublisherErrorDialog extends Vue {
  data () {
    return {
      dialog: false
    }
  }

  toggleDialog () {
    this.dialog = !this.dialog
  }

  goToChat () {
    this.toggleDialog()
    this.$emit('openChat')
  }

  handler () {
    this.dialog = false
    this.$widget.reTry()
  }
}
</script>
